export * from "./BorderedIcon";
